<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
        title="在线讣告"
        right-text="发布"
        fixed
        :z-index="99"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        :border="false"
     />
    <div class="navBarSpace"></div>
    <!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :offset="offset"
          :immediate-check="ischeck"
          @load="loadMore"
        >
        <div is-link center v-for="(item,index) in ObitList" :key="index" >
          <router-link class="obit-list van-hairline--bottom" :to="{path:'/ObitDetails?id=' + item.SerialNumber}" >
          <div class="hd">
            <div class="image">
              <van-image
                fit="cover"
                v-bind:src="item.PhotoPath"
              />
            </div>
          </div>
          <div class="bd">
            <h2 class="title">{{item.Title}}</h2>
            <p class="des van-multi-ellipsis--l3"> {{item.Content}}</p>
          </div>
          <p class="date">{{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</p>
        </router-link>
      </div>
    </van-list>
    </van-pull-refresh>
    <!-- <div>
      <router-link class="obit-list van-hairline--bottom" to="/ObitDetails" v-for="item in 3" :key="item.id">
        <div class="hd">
          <div class="image">
            <van-image
              fit="cover"
              src="https://img.yzcdn.cn/vant/cat.jpeg"
            />
          </div>
        </div>
        <div class="bd">
          <h2 class="title">王大海因病去世</h2>
          <p class="des van-multi-ellipsis--l3"> 刘登海四川广安因癌症导致器官衰竭于2015年6月17日6点08分逝世，享年73岁。</p>
        </div>
        <p class="date">2020-02-19</p>
      </router-link>
    </div> -->
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { Toast } from "vant";
	export default {
	  data() {
	    return {
        refreshing: false,
        loading: true,
        finished: false,
        offset: 100,
        ischeck: false,
        isLogin: false,
        options: null,
        ObitList : [],
	    };
    },
    computed : {
      ...mapGetters(["currentToken"])
    },
	  components: {
    },
    created(){
      this.init();
    },
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
    },
    beforeDestroy() {
      document.querySelector('body').removeAttribute('style')
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      onClickRight(){
        if (this.currentToken.isLogin){
          this.$router.push('/ObitAdd');
        }else{
          Toast("请登录后再进行发布！");
        }
      },
      init(){
        var that = this;
        that.options = {
          type: "GetObituaryList",
          pageIndex: 1
        };
        that.getObituaryList();
      },
      onRefresh() {
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        Object.assign(this.options, {
          pageIndex: 1
        });
        this.getObituaryList();
      },
      loadMore() {
        Object.assign(this.options, {
          pageIndex: this.options.pageIndex + 1
        });
        this.loading = true;
        this.getObituaryList();
      },
      getObituaryList(){
        var _this = this;
        this.$store
          .dispatch(_this.options)
          .then(result => {
            _this.loading = false;
            if (_this.refreshing) {
              _this.refreshing = false;
            }

            var ObitList = result.ObituaryExtendList;

            if(ObitList.length == 0){
              _this.finished = true;
              return;
            }

            if(_this.options.pageIndex > 1){
              for (let i = 0; i < ObitList.length; i++) {
                _this.ObitList.push(
                  ObitList[i]
                );
              }
            }else{
              _this.ObitList = result.ObituaryExtendList;
            }

            if (ObitList.length < 10) {
                _this.finished = true;
            }
        },
        error => {}
        );
      }
     
    }
	};
</script>

<style scoped>
.obit-list{
  padding: 15px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  position: relative;
  background-color: #fff;
  overflow: hidden;
}
.obit-list>.hd{
  width: 90px;
  height: 90px;
  margin-right: 12px;
}
.obit-list>.bd{
  flex: 1;
  overflow: hidden;
  position: relative;
}
.obit-list>.bd>.title{
  font-weight: normal;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #333;
}
.obit-list>.date{
  font-size: 12px;
  color: #bbb;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  bottom: 10px;
  right: 15px;
}
.obit-list>.bd>.des{
  font-size: 12px;
  color: #555;
  margin-top: 2px;
  line-height: 1.45
}
</style>
